import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostDownload } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const exportQuestions = createAsyncThunk(
  "exportQuestions",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPostDownload(urls?.exportMasterQuestions, arg);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportQuestionsSlice = createSlice({
  name: "exportQuestions",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    exportQuestionsReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [exportQuestions.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [exportQuestions.pending]: (state) => {
      state.isLoading = true;
      state.data = false;
      state.error = null;
    },
    [exportQuestions.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const { exportQuestionsReset } = exportQuestionsSlice.actions;
